<!-- A popup dialog to select a different brand -->
<app-choose-brand [displayBrandDialog] = "openBrandSelectionDialog" (chooseBrandEvent)="chooseBrand($event)"></app-choose-brand>

<div class="grid">
    <div class="col-9">
        <app-brand-admin-header></app-brand-admin-header>
    </div>
    <div class="col-1">
        <button pButton type="button" label="Brand" icon="pi pi-sitemap" iconPos="left" (click)="onChooseBrandClick($event)"  
             class="p-button-raised p-button-rounded" >
         </button>
    </div>  
    @if (isSimulatorFound) {
        <div class="col-2">
            <button pButton type="button" label="Download Simulator" icon="pi pi-sitemap" iconPos="left" (click)="onDownloadSimulator()"  
                class="p-button-raised p-button-rounded" >
            </button>
        </div>
    }
</div> 

@if (!isSimulatorFound) {
    <h4 class="text-center"><div [innerHTML]="promptText"></div></h4>
}

@if (isSimulatorFound) {
    <div [innerHTML]="htmlContent"></div>
}


